"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
require("./index.scss");
const ModalPortal = (props) => {
    const { isOpen, children, onClose } = props;
    const doClose = () => {
        onClose && onClose();
    };
    const modalRoot = document.getElementById('modal-root');
    if (!modalRoot) {
        return null;
    }
    return react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null, isOpen && (react_1.default.createElement("div", { className: `modal-portal-wrapper` },
        react_1.default.createElement("div", { className: 'overlay', onClick: doClose }),
        children))), modalRoot);
};
exports.default = ModalPortal;
